import { useState, useEffect } from 'react';
import './AboutUs.css';
import Translator from '../../translates/Translator';
import CompanyStaff from './CompanyStaff';
import CompanyProfile from './CompanyProfile';
import CompanyAchievements from './CompanyAchievements';
import Footer from '../../components/footer/Footer';
import teamPhotos from '../../assets/img/teamPhotos';
import hexes from '../../assets/img/hexes';
import usePageMeta from '../../hooks/usePageMeta';

const AboutUs = () => {
    const t = Translator();
    usePageMeta(`${t("about-us")} | IKA DATA`, t("seo-about-description"));
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const resize = () => {
        (window.innerWidth < 768) ? setIsMobile(true) : setIsMobile(false);
    }
    useEffect(() => { window.addEventListener("resize", resize); }, []);

    return (
        <div className='aboutus'>
            <div className='aboutus-banner'>
                <div className='staff-banner'>
                    <img src={teamPhotos.teamPhoto} alt='Our Staff' className='staff-banner-img' />
                    <div className='staff-banner-shadow-overlay'></div>
                </div>
                <div className='staff-heading-row'>
                    <h1 className='d-flex align-items-baseline flex-column'>
                        {t("meet-the-team")}
                        <span className='primary'> IKA DATA</span>
                        <div className='meet-the-team-hexes'>
                            <div className='meet-the-team-hexes-overlay'></div>
                            <img src={hexes.h3_80} alt='' className='row-hex3' />
                            <img src={hexes.h3_80} alt='' className='row-hex3' />
                            <img src={hexes.h3_80} alt='' className='row-hex3' />
                        </div>
                    </h1>
                </div>
            </div>
            <div className='aboutus-staff'>
                <CompanyStaff />
            </div>
            <div className='aboutus-profile'>
                <CompanyProfile isMobile={isMobile} />
            </div>
            <div className='aboutus-awards'>
                <CompanyAchievements />
            </div>
            <Footer />
        </div>
    );
}



export default AboutUs;